export const VERTICALS = [
  {
    icon: getComponent('IconsVerticalsHomeHealth'),
    home_icon: getComponent('IconsVerticalsHomeHealth'),
    title: 'Health Insurance',
    guides_index_title: 'Health',
    label: 'Health Insurance',
    cta_id: 'health_insurance_quote_btn',
    text: 'Get a quote in under 2 minutes.',
    badgeInfo: 'Save $300*',
    url: '/health-insurance/quote/form/step1/',
    guidesUrl: '/health-insurance/guides/',
    productPageUrl: '/health-insurance/'
  },
  {
    icon: getComponent('IconsVerticalsEnergy'),
    home_icon: getComponent('IconsVerticalsHomeEnergy'),
    title: 'Energy',
    guides_index_title: 'Energy',
    label: 'Electricity & Gas',
    cta_id: 'electricity_gas_quote_btn',
    text: 'Get a quote in less than a minute.',
    badgeInfo: 'Save $266 to $553**',
    url: '/energy/quote/form/step1/',
    guidesUrl: '/energy/guides/',
    productPageUrl: '/energy/'
  },
  {
    icon: getComponent('IconsVerticalsLife'),
    home_icon: getComponent('IconsVerticalsHomeLife'),
    title: 'Life Insurance',
    guides_index_title: 'Life',
    label: 'Life Insurance',
    cta_id: 'life_insurance_quote_btn',
    text: 'Get a quote in less than a minute.',
    url: '/life-insurance/quote/form/step1/',
    guidesUrl: '/life-insurance/guides/',
    productPageUrl: '/life-insurance/'
  },
  {
    icon: getComponent('IconsVerticalsHomeLoan'),
    home_icon: getComponent('IconsVerticalsHomeHouseLoans'),
    title: 'Home Loans',
    guides_index_title: 'Home Loans',
    label: 'Home Loans',
    cta_id: 'home_loans_quote_btn',
    text: 'Get a quote in less than a minute.',
    url: '/home-loans/quote/form/step1/',
    guidesUrl: '/home-loans/guides/',
    productPageUrl: '/home-loans/'
  },
  {
    icon: getComponent('IconsVerticalsCreditCard'),
    home_icon: getComponent('IconsVerticalsHomeCreditCard'),
    title: 'Credit cards',
    guides_index_title: 'Personal Finance',
    label: 'Credit cards',
    cta_id: 'credit_cards_quote_btn',
    text: 'Get a quote in less than a minute.',
    url: '/credit-cards/',
    guidesUrl: '/credit-cards/guides/',
    productPageUrl: '/credit-cards/'
  },
  {
    icon: getComponent('IconsVerticalsCarInsurance'),
    home_icon: getComponent('IconsVerticalsHomeCarInsurance'),
    title: 'Car Insurance',
    guides_index_title: 'Personal Finance',
    label: 'Car Insurance',
    cta_id: 'car_insurance_quote_btn',
    text: 'Get a quote in under 2 minutes.',
    badgeInfo: 'New',
    badgeTheme: 'primary',
    url: '/car-insurance/',
    guidesUrl: '/credit-cards/guides/',
    productPageUrl: '/car-insurance/'
  },
  {
    icon: getComponent('IconsVerticalsCarLoan'),
    home_icon: getComponent('IconsVerticalsHomeCarLoan'),
    title: 'Car Loans',
    guides_index_title: 'Personal Finance',
    label: 'Car Loans',
    cta_id: 'car_loans_quote_btn',
    text: 'Get a quote in less than a minute.',
    url: '/personal-loans/quote/form/step1',
    guidesUrl: '/credit-cards/guides/',
    productPageUrl: '/car-loans/'
  },
  {
    icon: getComponent('IconsVerticalsPersonalLoan'),
    home_icon: getComponent('IconsVerticalsHomePersonalLoan'),
    title: 'Personal Loans',
    guides_index_title: 'Personal Finance',
    label: 'Personal Loans',
    cta_id: 'personal_loans_quote_btn',
    text: 'Get a quote in less than a minute.',
    url: '/personal-loans/quote/form/step1/',
    guidesUrl: '/credit-cards/guides/',
    productPageUrl: '/personal-loans/'
  }
]

export const EXPERT_ANALYSIS_CATEGORY = [
  {
    slug: 'insurance',
    id: 'Insurance'
  },
  {
    slug: 'loans-and-credit',
    id: 'Loans and Credit'
  },
  {
    slug: 'utilities',
    id: 'Utilities'
  },
  {
    slug: 'savings-and-super',
    id: 'Savings and Super'
  },
  {
    slug: 'life-events',
    id: 'Life events'
  }
]
export const POST_TYPES = [
  {
    type: 'Guides',
    name: 'Guide',
    urlSlug: 'guides'
  },
  {
    type: 'Articles',
    name: 'Article',
    urlSlug: 'articles'
  },
  {
    type: 'Profiles',
    name: 'Profile',
    urlSlug: 'companies'
  }
]

export const INSURER_LISTS = [
  {
    label: 'Health Insurers',
    value: 'health-insurance'
  },
  {
    label: 'Life Insurers',
    value: 'life-insurance'
  },
  {
    label: 'Home Loan Lenders',
    value: 'home-loans'
  },
  {
    label: 'Energy Companies',
    value: 'energy'
  },
  {
    label: 'Credit Card Lenders',
    value: 'credit-cards'
  }
]

export const COMPANIES_DATA = {
  [VERTICAL.HEALTH_INSURANCE]: {
    title: 'Health Insurance',
    meta: {
      title: 'Compare Private Health Funds | Compare Club',
      description: 'Compare the pros and cons of over 30 Australian health insurance funds and companies. Read brief profiles on each. Click here.',
      ogUrl: 'https://compareclub.com.au/health-insurance/companies/'
    },
    ctaButtons: [
      {
        label: 'Compare now',
        to: '/health-insurance/quote/form/step1/',
        theme: 'secondary'
      }
    ],
    content: `<p class="mb-4">
        There are 38 private health funds in Australia, plus a number of different health insurance providers such as Qantas who offer health cover under their brand, but the actual product is provided on behalf of a health fund.
      </p>

      <p class="mb-4">
        Health funds can be open - where all adults in Australia can apply - or restricted. These restricted funds are only open to certain professions or unions, and their immediate families.
      </p>

      <p class="mb-4">We've listed Australia's main health funds below, along with an in-depth profile of the fund to help you decide what's right for you. Any insurer with a green tick is on our panel. Or if you just want to get started, compare health insurance providers now.</p>
    `
  },
  [VERTICAL.LIFE_INSURANCE]: {
    title: 'Life Insurance',
    meta: {
      title: 'Australian Life Insurance Companies | Compare Club',
      description: 'Compare the features and types of cover from over 20 life insurance companies. You can read brief profiles on each of the life insurers.',
      ogUrl: 'https://compareclub.com.au/life-insurance/companies/'
    },
    ctaButtons: [
      {
        label: 'Compare now',
        to: '/life-insurance/quote/form/step1/',
        theme: 'secondary'
      }
    ],
    content: `<p class="mb-4">
        Below you can see some of Australia's leading life insurers. View the insurer summaries below to get an overview of the fund, what product they offer, and how they rate for claims payouts. All the insurers we compare have a green tick next to them. Want to get started? <a href="/life-insurance/quote/form/step1/" class="underline">Compare life insurance</a> providers now.
      </p>
    `
  },
  [VERTICAL.HOME_LOANS]: {
    title: 'Home Loans',
    meta: {
      title: 'Our Home Loan Lenders | Compare Club',
      description: 'Looking for the best mortgage lenders? Look no further! Our expert insights and lender comparisons will help you find the perfect fit.',
      ogUrl: 'https://compareclub.com.au/home-loans/companies/'
    },
    ctaButtons: [
      {
        label: 'Compare now',
        to: '/home-loans/quote/form/step1/',
        theme: 'secondary'
      }
    ],
    content: `<p class="mb-4">
        Compare Club reviews loans from a panel of over 40 mortgage lenders. Below are some of Australia's main lenders - the ones we compare have a green tick alongside their name.
      </p>
    `
  },
  [VERTICAL.ENERGY]: {
    title: 'Energy',
    meta: {
      title: 'Australian Energy Companies | Compare Club',
      description: 'Find out more about Australia\'s leading energy companies and providers. Compare features and find the most competitive energy plans now.',
      ogUrl: 'https://compareclub.com.au/energy/companies/'
    },
    ctaButtons: [
      {
        label: 'Compare now',
        to: '/energy/quote/form/step1/',
        theme: 'secondary'
      }
    ],
    content: '<p class="mb-4">Not all providers are available in all states, so it pays to check before you buy.</p><p class="mb-4">We have compiled a list of some of Australia’s leading energy suppliers below,  Any provider marked with a green tick is part of our network. If you prefer to get started right away, compare energy providers now.</p>'
  },
  [VERTICAL.CREDIT_CARDS]: {
    title: 'Credit Cards',
    meta: {
      title: 'Compare Credit Card Companies & Providers In Australia - Compare Club',
      description: 'Find out more about Australia\'s leading credit card companies and providers. Compare features and find the most competitive credit card plans now.',
      ogUrl: 'https://compareclub.com.au/credit-cards/companies/'
    },
    ctaButtons: [
      {
        label: 'Compare now',
        to: '/credit-cards/',
        theme: 'secondary'
      }
    ],
    content: '<p class="mb-4">We work with Australia\'s leading financial institutions & credit card issuers. We compare some of these products to help match you to the right product.</p>'
  }
}
